import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "chargeItemDefinitionFilters",
  initialState: {},
  reducers: {
    setChargeItemDefinitionFilters(
      state: Record<string, unknown>,
      action: PayloadAction<Partial<Record<string, unknown>>>,
    ): void {
      Object.assign(state, action.payload);
    },
    updateChargeItemDefinitionFilter(
      state: Record<string, unknown>,
      action: PayloadAction<{ key: string; value: unknown }>,
    ): void {
      const { key, value } = action.payload;
      // eslint-disable-next-line no-param-reassign
      (state as Record<string, unknown>)[key] = value;
    },
    resetChargeItemDefinitionFilters() {
      // eslint-disable-next-line no-param-reassign, no-unused-vars, @typescript-eslint/no-unused-vars
      return {};
    },
  },
});

export const {
  setChargeItemDefinitionFilters,
  updateChargeItemDefinitionFilter,
  resetChargeItemDefinitionFilters,
} = slice.actions;
export const { reducer } = slice;

export default slice;
